import { useCallback, useEffect } from 'react';
import { Button } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { ArrowForward } from '@mui/icons-material';

import { Input } from '../../../components/Input';

import { SectionInputs } from './styles';
import {
  createAccountRequest,
  updateAccountRequest,
} from '../../../services/requests/contas/utils';

import useAuthStore from '../../../store/auth';
import useAccountStore from '../../../store/accounts';
import { Account } from '../../../services';

interface FormCriarContaProps {
  handleNext?: any;
  handleReset?: any;
  setAccountId?: any;
  accountId?: string;
  accountName?: string;
  setConta: (type: Account) => void;
  conta?: Account;
  setIsLoading: (status: boolean) => void;
  setIsLoadingText: (text: string) => void;
}

export const FormCriarConta = ({
  handleNext,
  handleReset,
  setAccountId,
  accountId,
  accountName,
  setConta,
  conta,
  setIsLoading,
  setIsLoadingText,
}: FormCriarContaProps) => {
  const user = useAuthStore(state => state.user);
  const setSelectedAccount = useAccountStore(state => state.setSelectedAccount);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      id: Yup.string().nullable(),
      name: Yup.string()
        .min(4, 'Mínimo de 4 Dígitos')
        .required('É necessário adicionar um Título.'),
    });
  }, []);

  const { control, handleSubmit, setValue } = useForm({
    resolver: yupResolver(formValidation()),
    reValidateMode: 'onBlur',
  });

  useEffect(() => {
    if (accountId && accountName) {
      setValue('id', accountId);
      setValue('name', accountName);
    }
  }, [accountId, accountName, setValue]);

  const handleCreateAccount = useCallback(
    async (formData: any) => {
      try {
        setIsLoading(true);
        setIsLoadingText('Carregando Informações da Conta');

        if (accountId) {
          const dataUpdate = {
            name: formData.name,
          };

          const responseUpdate = await updateAccountRequest(
            dataUpdate,
            accountId!,
            user?.id as string,
          );

          if (responseUpdate?.status === 200) {
            handleReset();
            setConta(responseUpdate?.data);
            setSelectedAccount(responseUpdate?.data);
          }
        } else {
          const data = {
            name: formData.name,
            status: true,
            companies_ids: [],
            companies: [],
            admins: [],
            admins_ids: [],
          };

          const response = await createAccountRequest(data, user?.id as string);

          if (response?.status === 201) {
            const contaRes = response?.data;

            setAccountId(contaRes?.id);
            handleNext();
            handleReset();
          }
        }
      } catch (error) {
        console.error('Error handleCreateAccount', error);
      } finally {
        setIsLoading(false);
      }
    },
    [
      accountId,
      handleNext,
      handleReset,
      setAccountId,
      setConta,
      setSelectedAccount,
      user?.id,
      setIsLoading,
      setIsLoadingText,
    ],
  );

  return (
    <form onSubmit={handleSubmit(handleCreateAccount)}>
      <SectionInputs>
        <Input
          name="id"
          control={control}
          fullWidth
          label="ID: será gerado automaticamente"
          sx={{ background: '#F5F5F5' }}
          disabled
        />
        <Input name="name" control={control} fullWidth label="Nome da Conta" />
      </SectionInputs>
      <Button
        endIcon={!accountId ? <ArrowForward /> : null}
        type="submit"
        variant="contained"
        className="btn-save"
        color="success"
        sx={{ color: '#FFF' }}
      >
        {!accountId ? 'Continuar' : 'Salvar'}
      </Button>
    </form>
  );
};
